import { createAsyncThunk } from "@reduxjs/toolkit";
import userApi from '../../Common/Api/UserApi'

export const fetchBooks = createAsyncThunk('books/fetchbooks', async ({ }, { rejectWithValue }) => {

    try {

        const res = await userApi.get('/ads');

        return res.data;

    } catch (error) {
        rejectWithValue(error);
    }

})

export const fetchCategories = createAsyncThunk('books/fetchCategories', async (number, { rejectWithValue }) => {
    try {
        const res = await userApi.get('/categories')
        // console.log(data)
        return res.data;
    } catch (error) {
        // return custom error message from API if any
        if (error.response && error.response.data.message) {
            return rejectWithValue(error.response.data.message)
        } else {
            return rejectWithValue(error.message)
        }
    }
})